<template>
  <div class="sk-grid" :style="{ '--cols': columns }">
    <div v-for="n in count" :key="'dsk-' + n" class="sk-card">
      <div class="sk sk-media" />
      <div class="sk-body">
        <div class="sk sk-line sk-line--lg" />
        <div class="sk sk-line sk-line--sm" />
        <div class="sk-row">
          <div class="sk sk-line sk-line--mid" />
          <div class="sk sk-pill" />
        </div>
        <div class="sk-tags">
          <div class="sk sk-tag" /><div class="sk sk-tag" /><div class="sk sk-tag" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscoverGridSkeleton",
  props: {
    count: { type: Number, default: 9 },
    columns: { type: Number, default: 3 },
  },
};
</script>

<style scoped>
.sk-grid {
  display: grid;
  grid-template-columns: repeat(var(--cols), minmax(0, 1fr));
  gap: 22px;
}
@media (max-width: 900px) {
  .sk-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 560px) {
  .sk-grid {
    grid-template-columns: 1fr;
  }
}
.sk-card {
  background: var(--color-card, #152338);
  border-radius: var(--radius-xl, 16px);
  overflow: hidden;
  box-shadow: var(--shadow-card, 0 12px 32px -4px rgba(25, 28, 30, 0.06));
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.sk-media {
  height: 200px;
  border-radius: 0;
  animation-delay: calc(var(--i, 0) * 0.04s);
}
.sk-body {
  padding: 18px 18px 20px;
}
.sk-line {
  height: 14px;
  margin-bottom: 10px;
  max-width: 100%;
}
.sk-line--lg {
  height: 20px;
  width: 72%;
}
.sk-line--sm {
  width: 48%;
  height: 12px;
}
.sk-line--mid {
  flex: 1;
  height: 14px;
  margin-bottom: 0;
}
.sk-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}
.sk-pill {
  width: 56px;
  height: 32px;
  border-radius: 999px;
  flex-shrink: 0;
}
.sk-tags {
  display: flex;
  gap: 8px;
  margin-top: 14px;
  flex-wrap: wrap;
}
.sk-tag {
  width: 72px;
  height: 24px;
  border-radius: 6px;
}
</style>
